import createLoyaltyApiRequest from '~/src/api/requests/loyaltyRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

export interface IInfoData {
    loyaltyNumber: string,
    loyaltyLevel: number,
    nextLevelDate: string,
    loyaltyCash: number,
    bonuses: number,
    expireDate: string,
    expireBonuses: number,
    progressBar: number,
    registrationDate: string,
    cashbackPercentAfterLevelUp: number,
}

export type TDataResponse = TResponse<IInfoData, any>;

interface IProps {
    domain: string,
    accessToken: string,
}

export const getInfo = async({ domain, accessToken }: IProps): Promise<TDataResponse> => {
    const url = '/v1/program/info';

    try {
        const response = await createLoyaltyApiRequest(domain, accessToken).get(url);

        return {
            isSuccess: true,
            payload: response.data,
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
